import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.assign.js"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import CountTime from '@/components/common/CountTime';
import TagItem from '@/components/common/TagItem'; // robType: 1.今日必抢,2.限时优惠 3.本周临演出

export default {
  // 今日必抢
  name: 'today-look',
  components: {
    CountTime: CountTime,
    TagItem: TagItem
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    gotoTodayPage: {
      type: Function
    }
  },
  data: function data() {
    return {
      // 单行展示今日必抢项目
      topList: [],
      // 三列展示的必抢项目
      projectList: []
    };
  },
  watch: {
    list: 'initList'
  },
  mounted: function mounted() {
    this.initList();
  },
  methods: {
    initList: function initList() {
      var _this = this;

      var list = this.list;

      if (list && list.length) {
        var todayList = list.map(function (a) {
          var reuslt = Object.assign({}, a);
          reuslt.discountText = _this.discountText(a);
          reuslt.timeText = _this.timeText(a);
          reuslt.countTime = _this.countTime(a); // 是否是即将开售

          reuslt.preSale = a.ticketStatus === 1;

          try {
            // 曝光打点
            window.seedAction({
              bid: a.dataSeed.viewBid,
              evt: 'view',
              custom: a.dataSeed.custom
            });
          } catch (error) {}

          return reuslt;
        });
        var topList = todayList.filter(function (a) {
          return a.reachRobStandard;
        });
        var projectList = todayList.filter(function (a) {
          return !a.reachRobStandard;
        });
        this.topList = topList;
        this.projectList = projectList.slice(0, 12);
        this.$nextTick(function () {
          var scrollEl = document.getElementById('today-scroll-view-stats');
          scrollEl.addEventListener('scroll', window.StatusReportData, false);
        });
      }
    },
    handleClick: function handleClick(project) {
      var _ref = project || {},
          performanceId = _ref.performanceId,
          dataSeed = _ref.dataSeed;

      if (!performanceId) return;
      this.go("/detail/".concat(performanceId), {
        _blank: true
      });

      if (dataSeed) {
        window.seedAction(dataSeed);
      }
    },
    // 计算项目的折扣
    discountText: function discountText(content) {
      if (!content) return '';
      var robType = content.robType;

      var _ref2 = content.projectExtendVO || {},
          maxDiscSingleValue = _ref2.maxDiscSingleValue,
          maxDiscSetValue = _ref2.maxDiscSetValue;

      if (robType !== 2) return ''; // 优先取套票折扣的展示

      if (maxDiscSetValue) {
        return "\u5957\u7968".concat(maxDiscSetValue, "\u6298\u8D77");
      }

      if (maxDiscSingleValue) {
        return "".concat(maxDiscSingleValue, "\u6298\u8D77");
      }

      return '';
    },
    // 计算项目的开演
    timeText: function timeText(content) {
      if (!content) return '';
      var projectStartTime = content.projectStartTime,
          robType = content.robType;
      if (robType !== 3) return '';
      return "\u672C\u5468\u6F14\u51FA";
    },
    // 计算项目的倒计时
    countTime: function countTime(content) {
      if (!content) return 0;
      var saleRemindVO = content.saleRemindVO,
          robType = content.robType;
      if (robType !== 1) return 0;

      var _ref3 = saleRemindVO || {},
          countdownTime = _ref3.countdownTime,
          needCountDown = _ref3.needCountDown,
          onSaleTime = _ref3.onSaleTime;

      var todayTime = new Date();
      todayTime.setHours(0);
      todayTime.setSeconds(0);
      todayTime.setMinutes(0);
      todayTime.setMilliseconds(0);
      var nextDay = todayTime.getTime() + 24 * 60 * 60 * 1000; // 只有开售当天才倒计时

      if (needCountDown && Date.now() < onSaleTime && onSaleTime <= nextDay) {
        return onSaleTime;
      }

      return 0; // return Date.now() + 23 * 60 * 60 * 1000
    },
    countDownEnd: function countDownEnd(_ref4) {
      var performanceId = _ref4.performanceId,
          type = _ref4.type;
      var index = this[type].findIndex(function (item) {
        return item.performanceId === performanceId;
      });

      if (index > -1) {
        this[type][index].preSale = 0;
      }
    }
  }
};